import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, IconX, LocaleX, ZMath, ZTime } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XDiv, XIconButton, XScroll, XText } from "IZOX/_X";
import ClaimUtils from "shared/_utils/ClaimUtils";
import { MdOutlineArrowRightAlt } from "react-icons/md";
import VarList from "shared/VarList";

/**
 * @augments {Component<Props, State>}
 */
class ViewClaimM extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetBankList();
      this.GetClaimTypes();
      this.GetRR();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ViewClaimM.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  GetBankList = async () => {
    let docs = await VarList.GetList("Bank");
    this.setState({
      banks: docs
    });
  }

  GetClaimTypes = async () => {
    let docs = await VarList.GetList("ClaimType");
    this.setState({
      claimTypes: docs
    });
  }

  GetRR = async () => {
    let docs = await VarList.GetList("RR");
    this.setState({
      rrs: docs
    });
  }

  renderTitleBar(){
    return (
      <HStack pH={16} shadow>
        <XText fontSize={16} bold>
          {LocaleX.Parse({
            EN: "Claim Details",
            TC: "索償詳細資料"
          })}
        </XText>
        <Spacer/>
        <XIconButton onPress={() => GFunc.CloseBackdrop()}>
          {IconX.Get("ant", "close", 20, ColorX.CSS("Stone"))}
        </XIconButton>
      </HStack>
    );
  }

  renderVertBox(label, value, style, containerStyle){
    return (
      <VStack width={120} HAlign="[" mH={5} style={containerStyle}>
        <HStack HAlign="[" fitWidthToContent>
          <XText color={ColorX.CSS("Gray4")} fullWidth
            fontSize={12}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <HStack HAlign="[" fitWidthToContent>
          <XText color={ColorX.CSS("Stone")} fontSize={13}
            style={style} fullWidth>
            {LocaleX.Parse(value)}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderMain(){
    let {doc} = this.props;
    let {banks, rrs} = this.state;
    let {_id, dcDoc, policyDoc, maidDoc, paid, bankID, bankACNo,
      status, claimIncurred, payAt, declinedReason} = doc ?? {};
    let {policyNo, startAt, endAt} = policyDoc ?? {};
    let _status = ClaimUtils.GetStatus(status);

    let _bank = VarList.GetOption(banks, bankID);
    let _rrs = VarList.GetOption(rrs, declinedReason);

    return (
      <XScroll fullWidth pV={20} pH={16}>
        <VStack spacing={5}>
          <HStack bgColor={ColorX.CSS(_status.color)} 
            spacing={10} HAlign="[" pV={10} pH={15}>
            <HStack spacing={5} HAlign="[">
              <XText color={ColorX.CSS("pureWhite")} bold>
                {LocaleX.Parse({
                  EN: "Claim no.",
                  TC: "索償編號"
                })}
              </XText>
              <XText color={ColorX.CSS("pureWhite")} bold>
                {_id}
              </XText>
            </HStack>
          </HStack>
          <HStack HAlign="[" pH={16} pV={8} bgColor={ColorX.CSS("pureWhite")}>
            {this.renderVertBox({
              EN: "Policy No.",
              TC: "保單編號"
            }, policyNo)}
            <HStack fitWidthToContent>
              {this.renderVertBox({
                EN: "Effective date",
                TC: "生效日期"
              }, startAt ? ZTime.Moment(startAt).format("DD/MM/YYYY") : "----")}
              <VStack width={16} VAlign="_">
                <XDiv mT={22}>
                  <MdOutlineArrowRightAlt color={ColorX.CSS("Axit")}/>
                </XDiv>
              </VStack>
              {this.renderVertBox({
                EN: "Expired date",
                TC: "失效日期"
              }, endAt ? ZTime.Moment(endAt).format("DD/MM/YYYY") : "----")}
            </HStack>
          </HStack>
          <HStack HAlign="[" VAlign="^" pH={16} pV={16} bgColor={ColorX.CSS("pureWhite")} fullHeight>
            <VStack width={"50%"} spacing={10} HAlign="[" VAlign="^" fullHeight>
              {this.renderVertBox({
                EN: "Policy holder",
                TC: "保單持有人"
              }, dcDoc.meta.fullName)}
              {this.renderVertBox({
                EN: "Helper's name",
                TC: "工人姓名"
              }, maidDoc?.fullName)}
              <VStack fullWidth spacing={10} HAlign="[">
                <VStack fitWidthToContent HAlign="[">
                  <HStack HAlign="[" fitWidthToContent>
                    <XText color={ColorX.CSS("Gray4")} fullWidth
                      fontSize={12}>
                      {LocaleX.Parse({EN: "Status", TC: "狀態"})}
                    </XText>
                  </HStack>
                  <XDiv bgColor={_status.bgColor} pH={8} width={92}>
                    <XText color={_status.color} textAlign="|" fontSize={13}>
                      {LocaleX.Parse(_status.label)}
                    </XText>
                  </XDiv>
                </VStack>
                {this.renderVertBox({
                  EN: "Paid Amount",
                  TC: "已付金額"
                }, paid ? `HKD $${ZMath.NumberWithCommas(paid)}` : "---")}
                {this.renderVertBox({
                  EN: "Payment date",
                  TC: "付款日期"
                }, payAt ? ZTime.Moment(payAt).format("DD/MM/YYYY") : "----")}
              </VStack>
            </VStack>
            <Spacer/>
            <VStack width={"50%"} spacing={20} HAlign="[" VAlign="^" fullHeight>
              <VStack fitWidthToContent HAlign="[">
                <HStack HAlign="[" fitWidthToContent>
                  <XText color={ColorX.CSS("Stone")} fullWidth bold
                    fontSize={16}>
                    {LocaleX.Parse(_bank?.name)}
                  </XText>
                </HStack>
                <HStack HAlign="[" fitWidthToContent>
                  <XText color={ColorX.CSS("Stone")} fullWidth
                    fontSize={14}>
                    {LocaleX.Parse(bankACNo)}
                  </XText>
                </HStack>
              </VStack>
              <VStack fitWidthToContent HAlign="[" VAlign="^" fullHeight>
                <HStack HAlign="[" fitWidthToContent>
                  <XText color={ColorX.CSS("Gray4")} fullWidth
                    fontSize={12}>
                    {LocaleX.Parse({EN: "Claim incurred", TC: "索償金額"})}
                  </XText>
                </HStack>
                <HStack HAlign="[" fitWidthToContent>
                  <XText color={ColorX.CSS("Axit")} fontSize={20} bold
                    fullWidth>
                    {claimIncurred ? `HKD $${ZMath.NumberWithCommas(claimIncurred)}` : "---"}
                  </XText>
                </HStack>
              </VStack>
            </VStack>
            <Spacer/>
          </HStack>
          {status === "Declined" &&
            <VStack fullWidth HAlign="[" pH={16} pV={8} bgColor={ColorX.CSS("pureWhite")}>
              <HStack HAlign="[" fitWidthToContent>
                <XText color={ColorX.CSS("Gray4")} fullWidth
                  fontSize={12}>
                  {LocaleX.Parse({
                    EN: "Declined Reaons:",
                    TC: "拒絕理由"
                  })}
                </XText>
              </HStack>
              <HStack HAlign="[" fitWidthToContent>
                <XText>
                  {LocaleX.Parse(_rrs?.name)}
                </XText>
              </HStack>
            </VStack>}
        </VStack>
      </XScroll>
    );
  }

  render(){
    return (
      <VStack bgColor={ColorX.CSS("NotQuiteWhite")}
        fullWidth maxHeight={window.innerHeight * 0.9}>
        {this.renderTitleBar()}
        {this.renderMain()}
      </VStack>
    );
  }

}

export default observer(ViewClaimM);
